import { TooltipProps, YAxisProps } from 'recharts';

import CustomTickY from '@/pages/Insights/components/Chart/CustomTickY';
import { TypeMetricUnit } from '@/pages/Insights/Insights.types';

import getFormattedValue from './getFormattedValue';

export const defaultTooltipStyle: TooltipProps<any, any> = {
  animationDuration: 300,
  cursor: { stroke: 'var(--colors-text\\/body)' },
  wrapperStyle: {
    // Revert default box-shadow that's coming from Bitkit.
    boxShadow: 'unset',
  },
};

const defaultActiveDotStyle = { stroke: 'var(--colors-text\\/body)', strokeWidth: 1, r: 5 };

export const defaultLineStyle = {
  connectNulls: true,
  strokeWidth: 2,
  animationDuration: 300,
  dot: false,
  activeDot: defaultActiveDotStyle,
};

// Units whose formatted labels include a unit suffix (e.g. "125.78 GiB",
// "5.00 GB/s") are wider than percentages/counts and need a roomier axis,
// otherwise the label wraps and the suffix gets clipped.
const WIDE_LABEL_UNITS: TypeMetricUnit[] = ['bytes', 'bytesToMB', 'gibibyte', 'gigabytePerSecond', 'gigabitPerSecond'];

export const defaultYaxisStyle = (unit: TypeMetricUnit): YAxisProps => {
  return {
    width: WIDE_LABEL_UNITS.includes(unit) ? 104 : 80,
    allowDataOverflow: true,
    axisLine: true,
    tickLine: true,
    tickCount: 4,
    interval: 'preserveStartEnd',
    tick: <CustomTickY formatter={(value: number): string => getFormattedValue(unit, value)} />,
  };
};

export const defaultCartesianGridStyle = (height: number, topSpacing = 0, cartesianCustomBg = false) => {
  return {
    horizontal: false,
    vertical: false,
    fill: cartesianCustomBg ? 'var(--colors-status\\/critical\\/bg)' : 'var(--colors-background\\/secondary)',
    y: topSpacing,
    height: height - 30 - topSpacing,
  };
};
